export default __webpack_public_path__ + "static/media/apps-resignation.ee836df8.png";